import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import {Observable} from 'rxjs/internal/Observable';
import {Site} from '../../../app/+home/+my-libraries/shared/models/site.model';

@Injectable({
  providedIn: 'root'
})
export class NodeContextService {
  private _currentNodeSubject: BehaviorSubject<Site> = new BehaviorSubject(null);
  currentNode$: Observable<any> = this._currentNodeSubject.asObservable();

  constructor() {

  }

  setCurrentNode(node: any) {
    this._currentNodeSubject.next(node);
  }
}
